/**
 * Главная страница - обрабатывает логику активации и редиректов
 */
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDeviceStore } from '../store/deviceStore'
import { useUIStore } from '../store/uiStore'
import { ScannerPage } from './ScannerPage'
import { AdminPage } from './AdminPage'
import { RegistrationGuidePage } from './RegistrationGuidePage'

export function HomePage() {
  const navigate = useNavigate()
  const deviceStore = useDeviceStore()
  const uiStore = useUIStore()

  useEffect(() => {
    // Проверяем наличие сохраненного токена активации
    const pendingActivationStr = localStorage.getItem('pending_activation')
    
    if (pendingActivationStr && !deviceStore.isRegistered) {
      try {
        const pendingActivation = JSON.parse(pendingActivationStr)
        const { token, timestamp } = pendingActivation
        
        // Проверяем что токен свежий (не старше 1 часа)
        const hourAgo = Date.now() - 60 * 60 * 1000
        if (timestamp > hourAgo && token) {
          console.log('[HomePage] Found pending activation token, redirecting to activation...')
          // Очищаем токен из localStorage
          localStorage.removeItem('pending_activation')
          // Редиректим на страницу активации
          navigate(`/activate/${token}`, { replace: true })
          return
        } else {
          console.log('[HomePage] Pending activation token expired, removing...')
          localStorage.removeItem('pending_activation')
        }
      } catch (error) {
        console.error('[HomePage] Error parsing pending activation:', error)
        localStorage.removeItem('pending_activation')
      }
    }
  }, [navigate, deviceStore.isRegistered])

  // Если устройство зарегистрировано, показываем соответствующую страницу
  if (deviceStore.isRegistered) {
    return uiStore.isAdminMode ? <AdminPage /> : <ScannerPage />
  }

  // Если не зарегистрировано и нет токена, показываем гайд
  return <RegistrationGuidePage />
}
